import Transformer from './Transformer';

export default class ProductTransformer extends Transformer {
  static fetchCollection(items, footnotes) {
    return items.map(item => this.fetch(item, footnotes));
  }

  static fetch(product, footnotes) {
    product.texts = {};
    product.productDescription.texts.forEach(t => {
      product.texts[t.name] = t.text;
      if (t.isImportant) {
        product[t.name + 'Important'] = true;
      }
    });

    product.footnotes = [];
    product.productDescription.footnotes.forEach(fn => this.addFootnote(fn, product));

    product.textLists = {};
    Object.entries(product.productDescription.textLists).forEach(([key, value]) => {
      product.textLists[key] = [];
      value.forEach(v => {
        product.textLists[key].push(v.text);
      });
    });

    product.images = {};
    product.gallery = [];

    product.productDescription.images.forEach(t => {
      const isGallery = t.name === 'imageGallery' || t.name === 'thumbnailGallery';
      if (isGallery) {
        let galleryItem = product.gallery[t.imageId - 1];
        if (!galleryItem) {
          galleryItem = product.gallery[t.imageId - 1] = {};
        }

        galleryItem[t.name] = {
          alt: t.alt,
          resourcePath: t.resourcePath,
        };
      } else {
        product.images[`${t.name}Alt`] = t.alt;
        product.images[`${t.name}ResourcePath`] = t.resourcePath;
      }
    });
    product.gallery = product.gallery.filter(n => n !== undefined);

    // prevent backend error caused by misconfiguration in product configurator
    product.gallery.forEach(galleryitem => {
      if (!galleryitem.imageGallery && galleryitem.thumbnailGallery) {
        galleryitem.imageGallery = Object.assign({}, galleryitem.thumbnailGallery);
      }
      if (galleryitem.imageGallery && !galleryitem.thumbnailGallery) {
        galleryitem.thumbnailGallery = Object.assign({}, galleryitem.imageGallery);
      }
    });

    product.hyperlinks = {};
    product.productDescription.hyperlinks.forEach(t => {
      product.texts[t.name] = t.text;
      product.hyperlinks[`${t.name}DisplayName`] = t.displayName;
      product.hyperlinks[`${t.name}Url`] = t.url;
    });

    product.cntTerminated = 0;
    product.cntNotTerminated = 0;
    if (product.productOptions) {
      product.productOptions.forEach(o => {
        o.isTerminated = this.isOptionTerminated(o);
        o.isFirstTerminated = !!(o.isTerminated && !product.cntTerminated);
        o.isFirstNotTerminated = !o.isTerminated && !product.cntNotTerminated;
        if (o.isTerminated) product.cntTerminated += 1;
        else product.cntNotTerminated += 1;
        if (o.isTerminated || product.texts.earliestCancellationDateOverrideTextMyProducts === '-') {
          o.cancellationDate = null;
        } else if (product.texts.earliestCancellationDateOverrideTextMyProducts != null) {
          o.cancellationDate = product.texts.earliestCancellationDateOverrideTextMyProducts;
        }
      });
    }

    product.footnotes.forEach(f => {
      // consider only footnotes with format "prefix) text" and split into prefix and text
      const pos = f.indexOf(')');
      if (pos > 0) {
        const prefix = f.substring(0, pos);
        const text = f.substring(pos + 1).trim();
        const fn = { prefix, text };
        footnotes.add(fn);
      }
    });

    this.parseFootnotes(product, footnotes);

    if (!product.price) product.price = {};

    return product;
  }

  static addFootnote(fn, product) {
    if (fn.name === 'footNoteCatalogue') {
      product.footnotes.push(fn.text);
    }
  }

  /**
   * Walk through all possible texts containing footnote-references
   * in order of appearance in the dom of current page
   *
   * @param product
   * @param footnotes
   */
  static parseFootnotes(product, footnotes) {
    // The promotion disruptor overwrites the regular disruptor. Only look for footnotes in the promotion disruptor if both kinds are defined.
    const catalogueDisruptorText = product.texts.cataloguePromotionDisruptorText ? 'cataloguePromotionDisruptorText' : 'catalogueRegularDisruptorText';
    ['productName', catalogueDisruptorText, 'productDescriptionCatalogue', 'regularPriceOverrideText', 'promotionPriceOverrideText'].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }

  static isOptionTerminated(o) {
    return o.status === 'terminated' || o.status === 'failed';
  }

  static removeExpFromName(product, expression) {
    ['buttons', 'footnotes', 'hyperlinks', 'images', 'textLists', 'texts'].forEach(propertyType => {
      if (product[propertyType]) {
        Object.keys(product[propertyType]).forEach(oldKey => {
          if (expression.test(oldKey)) {
            const newKey = oldKey.replace(expression, '');
            product[propertyType][newKey] = product[propertyType][oldKey];
          }
        });
      }
    });
    return product;
  }
}
